import { PredicateHelpers } from '@headless-workspace/utils';
import { ProductDetailBannerDTO, ProductDetailBannersDTO } from './ProductDetailBannerDTO';
import { ProductDetailBannerType } from './ProductDetailBannerType';
import { BrandCornerBannerValue, mapBrandCornerBanner } from './brandCornerBanner/BrandCornerBannerValue';
import { mapMarketingBanner, MarketingBannerValue } from './marketingBanner';
import { mapPromoBanner, PromoBannerValue } from './promoBanner';

export type ProductDetailBannerValue = PromoBannerValue | MarketingBannerValue | BrandCornerBannerValue;

export type ProductDetailBannersValue = ProductDetailBannerValue[];

export const mapProductDetailBanner = (banner: ProductDetailBannerDTO): ProductDetailBannerValue | null => {
    switch (banner.type) {
        case ProductDetailBannerType.Fidelity:
        case ProductDetailBannerType.GiftWithPurchase:
            return mapPromoBanner(banner);
        case ProductDetailBannerType.Marketing:
            return mapMarketingBanner(banner);
        case ProductDetailBannerType.BrandCorner:
            return mapBrandCornerBanner(banner);
        default:
            return null;
    }
};

export const mapProductDetailBanners = (DTOBanners: ProductDetailBannersDTO): ProductDetailBannersValue => {
    const banners = DTOBanners.map((banner) => mapProductDetailBanner(banner));
    return banners.filter(PredicateHelpers.notNullOrUndefined) as ProductDetailBannersValue;
};
